export const CODE_SPACE = 32;
export const CODE_HASH = 35;
export const CODE_PERCENT = 37;
export const CODE_AMPERSAND = 38;
export const CODE_PLUS = 43;
export const CODE_FORWARD_SLASH = 47;
export const CODE_COLON = 58;
export const CODE_SEMICOLON = 59;
export const CODE_EQUALS = 61;
export const CODE_QUESTION_MARK = 63;
export const CODE_AT = 64;
export const CODE_SQUARE_BRACKET_OPEN = 91;
export const CODE_SQUARE_BRACKET_CLOSE = 93;
//# sourceMappingURL=const.js.map